import React from "react";
import ReactDOM from "react-dom";

interface ConfirmationProps {
  onClose: () => void;
  body: string;
  closeButtonName: string;
  title:string;
}

const ViewPopup: React.FC<ConfirmationProps> = ({
  onClose,
  closeButtonName,
  body,
  title
}) => {
  // Predefined correct order
  const menuItemsOrder = [
    "Hospital Profiling",
    "Company Profiling",
    "Event Organiser Profiling",
    "Content Marketing",
    "Event Listing",
    "Banner ads",
    "Email marketing",
    "Newsletter ads",
    "Print ad",
  ];

  const formattedBody = body
  ? body.replace(/\n/g, '<br/>')
  : 'NA';

  return ReactDOM.createPortal(
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-30">
      <div className="bg-white rounded-lg shadow-lg overflow-hidden sm:w-1/3 md:w-[672px] w-10/12">
      <div
          className="bg-white px-4 py-3 sm:px-6 sm:flex sm:flex-row-revers"
          style={{
            boxShadow: "0px -16px 50px 0px #0000000D",
          }}
        >
         <h3 className="text-2xl font-bold text-gray-900 text-left pt-4 ">
                 {title}
                </h3>
          
         

        </div>
        <div className="px-5 h-[70vh] scroolCls overflow-y-scroll"><div className="flex items-center">
            <div className="ml-4 ">
            {/* <h3 className="text-2xl font-bold text-gray-900 text-left pt-4 ">
                 {title}
                </h3> */}
             <p
  className="text-base text-gray-900 font-medium text-left mt-3.5 mb-2.5"
  dangerouslySetInnerHTML={{ __html: formattedBody }}
/>


            </div>
          </div>
        </div>

        <div
          className="bg-white px-4 py-3 sm:px-6 sm:flex justify-end sm:flex-row-revers"
          style={{
            boxShadow: "0px -16px 50px 0px #0000000D",
          }}
        >
          <button
            type="button"
            className="mt-3  inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-6 w-[150px] py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:w-auto sm:text-sm"
            onClick={onClose}
          >
            {closeButtonName}
          </button>
          
         

        </div>
      </div>
    </div>,
    document.body
  );
};


export default ViewPopup
